type RuntimeWindow = Window & {
  __RUNTIME_CONFIG__?: Record<string, unknown>
}

function configuredValue(runtimeKey: string, viteKey: string): string {
  if (typeof window !== 'undefined') {
    const runtimeValue = (window as RuntimeWindow).__RUNTIME_CONFIG__?.[runtimeKey]
    if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
      return String(runtimeValue)
    }
  }
  const viteValue = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env?.[viteKey]
  return viteValue === undefined || viteValue === null ? '' : String(viteValue)
}

export function isMicrosoftAdsEnabled(): boolean {
  return configuredValue('MICROSOFT_ADS_ENABLED', 'VITE_MICROSOFT_ADS_ENABLED') === 'true'
}
